import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { OperationsService } from '../../../../core/services/operations.service';
import { ArchiviaPraticaRequest } from '../../../models/dto/archivia-pratica-request';
import { PraticaBase } from '../../../models/pratica/pratica-base';

declare var openModal: any;
declare var closeModal: any;

@Component({
    selector: 'div [archivia-pratica-mod-update]',
  templateUrl: 'archivia-modal.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'', '[attr.id]': '\'modaleDataArchiviazione\''}
})

export class ArchiviaModal {

  request: ArchiviaPraticaRequest;
  dataArchiviazioneForm: FormGroup;
  pratica: PraticaBase;
  tipoPratica: string;
  today:Date = new Date();

  constructor(private operationService: OperationsService,
    private campiForm: FormBuilder, private frontEndMapping: FrontEndMapping) {
  }

  createForm() {
    this.frontEndMapping.getListTipiPratica(this.pratica.tipoPratica.id).subscribe(res => {
      this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
    });
    this.request = new ArchiviaPraticaRequest();
    this.request.idPratica = this.pratica.id;
    this.dataArchiviazioneForm = this.campiForm.group({
      dataArchiviazione: [this.request.dataArchiviazione, Validators.required]
    });
  }

   inizializza(pratica: PraticaBase) {
     this.pratica = pratica;
     this.createForm();
     openModal('modaleDataArchiviazione');
   }

  private update() {
    this.operationService.archiviaPratica(this.pratica.tipoPratica.id, this.request).subscribe(response => this.praticaArchiviata());
    // this.operationService.archiviaPratica(ServicePathsSettings.URL_ARCHIVIA_PRATICA, this.request).subscribe(response => this.praticaArchiviata());
  }

  private praticaArchiviata() {
    this.pratica.archiviata = true;
    closeModal('modaleDataArchiviazione');
  }
}
